import { decrypt } from '../../utils/Helper/encryption';
import { clearSession, getJwtTokenFromSession } from '../../utils/Helper/helper';
import createGenericSlice, { GenericState } from '../wrapper/sliceWrapper';

interface IUserDetails {
  isLoggedIn: boolean;
  isSessionValid: boolean;
  userData: string;
}

const initialState: GenericState<IUserDetails> = {
  data: {
    isLoggedIn: getJwtTokenFromSession() !== null,
    isSessionValid: getJwtTokenFromSession() !== null,
    userData: decrypt(sessionStorage.getItem('loginToken'))
  },
  status: 'loading'
};

const sessionSlice = createGenericSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    // On user login
    loginUser: (state) => {
      state.data = {
        isSessionValid: true,
        isLoggedIn: true,
        userData: state.data.userData
      };
    },
    // On session expired
    invalidateSession: (state) => {
      state.data = {
        isSessionValid: false,
        isLoggedIn: true,
        userData: ''
      };
      state.status = 'loading';
    },
    // Logout: Reset to initial state
    logoutUser: (state) => {
      clearSession();
      state.data = {
        isSessionValid: false,
        isLoggedIn: false,
        userData: ''
      };
    },
    // Update userData
    updateUserData: (state, action) => {
      state.data = {
        isSessionValid: state.data.isSessionValid,
        isLoggedIn: state.data.isLoggedIn,
        userData: action.payload
      };
    }
  }
});

export const { loginUser, logoutUser, invalidateSession, updateUserData } = sessionSlice.actions;
export default sessionSlice.reducer;
